import {
  allTicketsAccess,
  currentUser,
  DOCTOR_BOOKING_FLAG,
  THIRD_PARTY_MEDREPS,
} from "modules/utilities/utility";
import { voitekkUserIdMap } from "modules/utilities/voitekkUSerIdMap";
import api from "../../../../../src/api/index";
import secureLocalStorage from "react-secure-storage";

export function allTicketsData(sd, ed, PageNumber, query) {
  if (allTicketsAccess.includes(currentUser) || DOCTOR_BOOKING_FLAG) {
    return api.get(`v2/get-all-tickets/${sd}/${ed}?pageNumber=${PageNumber}${query && query.length ? `&${query}` : ``}`);
  } else {
    const apiEndPoint =
      THIRD_PARTY_MEDREPS.includes(currentUser) &&
      !Object.keys(voitekkUserIdMap).includes(secureLocalStorage.getItem("id"))
        ? `v3/get-tickets-acl/${secureLocalStorage.getItem(
            "id"
          )}/${sd}/${ed}?tab=all_tickets`
        : `v2/get-tickets-acl/${secureLocalStorage.getItem(
            "id"
          )}/${sd}/${ed}?tab=all_tickets`;
    return api.get(apiEndPoint);
  }
}
export function allTicketsStatsData(sd, ed, query) {
  if (allTicketsAccess.includes(currentUser)) {
    return api.get(`v2/get-all-tickets-stats/${sd}/${ed}${query && query.length ? `?${query}`:''}`);
  } else {
    const apiEndPoint =
      THIRD_PARTY_MEDREPS.includes(currentUser) &&
      !Object.keys(voitekkUserIdMap).includes(secureLocalStorage.getItem("id"))
        ? `v3/get-tickets-acl/${secureLocalStorage.getItem(
            "id"
          )}/${sd}/${ed}?tab=all_tickets`
        : `v2/get-tickets-acl/${secureLocalStorage.getItem(
            "id"
          )}/${sd}/${ed}?tab=all_tickets`;
    return api.get(apiEndPoint);
  }
}
export function downloadTickets(query, payload) {
  return api.post(`download-all-tickets${query && query.length ? `?${query}` : ``}`,payload);
}

export function statsUserData() {
  return api.get("users");
}

export function callAction(id) {
  return api.get(`case/${id}?is_unified_ticketing=true`);
}

export function getAllActiveAssignee() {
  return api.get("get-all-assignee");
}

export function ticketBulkUpdateV2(payload) {
  return api.put("update-bulk-ticket", payload);
}
export function getAllAssigness() {
  return api.get('/ticket-resolve-assignee');
};
export function resolvedUserAssignee() {
  return api.get(`/resolved-assignees`);
}